import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Checkmark: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="2 1 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.802 4.99895L6.79991 11.001L3.59446 7.79558"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
